module.exports = __webpack_public_path__ + "static/website-build-95b2483e22dc1b359e044b3f1d35d948.svg";